import { Divider, Stack } from '@mantine/core';
import { ValidateStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import MultiDataInputSelector from '@/pages/Editor/components/SharedFields/DataInputSelector/MultiDataInputSelector/MultiDataInputSelector.tsx';
import OutputNameField from '@/pages/Editor/components/SharedFields/OutputNameField.tsx';
import ValidateStepFields from '@/pages/Editor/components/StepSidebar/StepForms/ValidateStep/ValidateStepFields.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: ValidateStep;
};

export function ValidateStepForm({ step }: props) {
  return (
    <Stack gap={'md'}>
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      <Divider mt="xs" mb={'0'} />
      <MultiDataInputSelector
        step={step}
        label="Data to validate"
        description="Select the data this check should evaluate. Only data available in this step's scope is listed; a promoted item was explicitly exposed from a branch or loop. This is separate from optional rule or reference data below."
      />
      <Divider mt="xs" mb={'0'} />
      <ValidateStepFields step={step} />
      <OutputNameField step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
